var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center donation"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("Sorry, we can't find the campaign you are looking for.")])])])
}]

export { render, staticRenderFns }